import { StateStorage } from 'zustand/middleware'
import { createStore } from '../.'
import { PlugbookRecord } from '../../clients/PlugbookClient'

interface WalletPropertiesStore {
  walletNames: { [key: string]: string }
  walletEthAddresses: { [key: string]: string }
  walletSolAddresses: { [key: string]: string }
  walletDogeAddresses: { [key: string]: string }
  walletPlugbookRecords: { [key: string]: PlugbookRecord }
  walletFundingBaselines: { [key: string]: 'empty' | 'funded' }
  setWalletName: (walletId: string, name: string) => void
  setWalletEthAddress: (walletId: string, address: string) => void
  setWalletSolAddress: (walletId: string, address: string) => void
  setWalletDogeAddress: (walletId: string, address: string) => void
  setWalletPlugbookRecord: (walletId: string, plugbookRecord: PlugbookRecord) => void
  setWalletFundingBaseline: (walletId: string, baseline: 'empty' | 'funded') => void
}

export const createWalletPropertiesStore = (storage: StateStorage) =>
  createStore<WalletPropertiesStore>(
    storage,
    (set, get) => ({
      walletNames: {},
      walletEthAddresses: {},
      walletSolAddresses: {},
      walletDogeAddresses: {},
      walletPlugbookRecords: {},
      walletFundingBaselines: {},
      setWalletName: (walletId, name) => {
        const names = get().walletNames
        set({ walletNames: { ...names, [walletId]: name } })
      },
      setWalletEthAddress: (walletId, address) => {
        const ethAddresses = get().walletEthAddresses
        set({ walletEthAddresses: { ...ethAddresses, [walletId]: address } })
      },
      setWalletSolAddress: (walletId, address) => {
        const solAddresses = get().walletSolAddresses
        set({ walletSolAddresses: { ...solAddresses, [walletId]: address } })
      },
      setWalletDogeAddress: (walletId, address) => {
        const dogeAddresses = get().walletDogeAddresses
        set({ walletDogeAddresses: { ...dogeAddresses, [walletId]: address } })
      },
      setWalletPlugbookRecord: (walletId, plugbookRecord) => {
        const walletPlugbookRecords = get().walletPlugbookRecords
        set({ walletPlugbookRecords: { ...walletPlugbookRecords, [walletId]: plugbookRecord } })
      },
      setWalletFundingBaseline: (walletId, baseline) => {
        const walletFundingBaselines = get().walletFundingBaselines
        set({ walletFundingBaselines: { ...walletFundingBaselines, [walletId]: baseline } })
      },
    }),
    {
      persist: {
        name: 'walletProperties',
        version: 0,
      },
    }
  )
